import { createFileRoute } from "@tanstack/react-router";
import { parseHubFilters } from "@/components/outreach/hub-filters";
import { TextCampaignDetailPage } from "@/components/text-banking/TextCampaignDetailPage";

export const Route = createFileRoute(
	"/_app/_/contacts/text-banking/$campaignId",
)({
	// This route is reached only from the Outreach hub, so it always backs out
	// there, carrying the hub filters forwarded in the search params.
	validateSearch: parseHubFilters,
	component: ContactsTextBankingDetailPage,
});

function ContactsTextBankingDetailPage() {
	const { campaignId } = Route.useParams();
	const filters = Route.useSearch();
	return (
		<TextCampaignDetailPage
			textCampaignId={Number(campaignId)}
			backTo="/outreach"
			backLabel="Back to outreach"
			backSearch={filters}
		/>
	);
}
